// PERM: access-all-reports
// NOTE: myyntipaallikkoe slug doesn't even exist (should be myyntipaeaellikkoe), so this has always returned false. Working as intended or should be changed to correct slug?
// used in reportsPage/selectors, API returns all reports instead of team's reports if this returns false
export const isSalesmanagerUser = user =>
	!!user.roles.find(r => r.slug === 'myyntipaallikkoe');
